import { render } from "./cpt-password-option.vue?vue&type=template&id=0bd217ca"
import script from "./cpt-password-option.vue?vue&type=script&lang=js"
export * from "./cpt-password-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__